import React from 'react';
import Button from '../ui/Button';
import { ChevronRight, Phone, MessageSquare, Mail } from 'react-feather';
import { trackEvent, trackConversion } from '../../services/trackingService';
import { useData } from '../../context/DataContext';
import { useTranslation, Trans } from 'react-i18next';
import LocalizedLink from '../ui/LocalizedLink';


const Hero: React.FC = () => {
  const { t } = useTranslation('common');
  const { firmInfo } = useData();

  const baseUrl = "https://images.pexels.com/photos/27081659/pexels-photo-27081659.jpeg?auto=compress&cs=tinysrgb&fm=webp&q=50";
  
  const srcSet = `
    ${baseUrl}&w=400 400w,
    ${baseUrl}&w=800 800w,
    ${baseUrl}&w=1200 1200w,
    ${baseUrl}&w=1600 1600w
  `;
  
  return (
    <div className="relative overflow-hidden">
      <div className="absolute inset-0 z-10 hero-overlay"></div>
       {/* LCP Optimization: Use an <img> tag with srcset and sizes for responsive, optimized image loading. */}
      <img
        src={`${baseUrl}&w=1600`}
        srcSet={srcSet}
        sizes="100vw"
        alt="Salt Lake City skyline at night, representing The Action Firm's commitment to Utah clients."
        className="absolute inset-0 w-full h-full object-cover"
        fetchPriority="high"
        loading="eager"
        width="1920"
        height="1080"
        crossOrigin="anonymous"
      />
      <div className="relative z-20 mx-auto max-w-7xl px-6 pt-24 pb-32 md:pt-32 md:pb-40 text-center">
        <h1
          className="text-5xl md:text-7xl font-extrabold font-serif tracking-tight drop-shadow-2xl"
        >
          <Trans
            i18nKey="homePage.heroTitle"
            t={t}
            components={{ gold: <span className="gold-gradient-text" /> }}
          />
        </h1>
        <h2
          className="mt-6 max-w-3xl mx-auto text-2xl md:text-3xl font-semibold text-white tracking-tight"
        >
          {t('homePage.heroSubtitle')}
        </h2>
        <p
          className="mt-4 max-w-2xl mx-auto text-lg md:text-xl text-white"
        >
          {t('homePage.heroParagraph')}
        </p>
        <div
          className="mt-10"
        >
          <Button to="/contact" isLocalized variant="primary" icon={<ChevronRight size={20} />}>
            {t('buttons.getFreeCaseReview')}
          </Button>
        </div>
        <div
            className="mt-8 flex flex-wrap items-center justify-center gap-4"
        >
             <a href={`tel:${firmInfo.telephone}`} onClick={() => { trackEvent('click_to_call', { location: 'hero' }); trackConversion('Contact', { content_name: 'click_to_call', location: 'hero' }); }} className="inline-flex items-center gap-2 text-sm font-medium text-white/90 transition-colors rounded-full px-4 py-2 bg-white/10 border border-white/10 hover:bg-white/20 glass-effect">
                 <Phone size={16} className="text-brand-gold-light" /> {t('nav.call247')}
            </a>
            <a href={`sms:${firmInfo.telephone}`} className="inline-flex items-center gap-2 text-sm font-medium text-white/90 transition-colors rounded-full px-4 py-2 bg-white/10 border border-white/10 hover:bg-white/20 glass-effect">
                <MessageSquare size={16} className="text-brand-gold-light" /> {t('nav.textNow')}
            </a>
            <a href="mailto:intake@theactionfirm.law" className="inline-flex items-center gap-2 text-sm font-medium text-white/90 transition-colors rounded-full px-4 py-2 bg-white/10 border border-white/10 hover:bg-white/20 glass-effect">
                <Mail size={16} className="text-brand-gold-light" /> {t('nav.emailUs')}
            </a>
        </div>
      </div>
    </div>
  );
};

export default Hero;